import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzWa1 } from './pages'

type TIdToPageMapWoofzWa1 = Record<PageIdWoofzWa1, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_WA1: TIdToPageMapWoofzWa1 = {
  [PageIdWoofzWa1.SUBSCRIPTIONS_WA1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_wa1/pages/subscriptions/Subscriptions'
      ).then((m) => ({ default: m.Subscriptions })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_wa1/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzWa1.CANCEL_OFFER_WA1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_wa1/pages/cancel-offer/CancelOffer'
      ).then((m) => ({ default: m.CancelOffer })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_wa1/pages/cancel-offer/CancelOffer'),
  },
  [PageIdWoofzWa1.DOWNLOAD_WA1]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_wa1/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_wa1/pages/download-app/DownloadApp'),
  },
}
